import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function BonusSection() {
  const bonuses = [{
    title: 'Mejores Plantas para Empezar',
    desc: 'Guía clara para saber exactamente qué plantar',
    image: 'https://cdn.magicpatterns.com/uploads/1hi6gDV2GP9eHVt9XWUXwP/BONUS1.jpg'
  }, {
    title: 'Plantas y Mascotas',
    desc: 'Qué plantas son seguras y cuáles evitar',
    image: 'https://cdn.magicpatterns.com/uploads/rj4nGY2D3ZHvQaeppRTyvd/BONUS2.jpg'
  }, {
    title: 'Sistema Imprimible',
    desc: 'Checklists, planner y seguimiento',
    image: 'https://cdn.magicpatterns.com/uploads/1rUL17xnj4fp1exqKSDWXv/BONUS3.jpg'
  }, {
    title: 'Pack de Plantillas Descargables',
    desc: 'Organiza, planifica y mantén tu huerta de forma simple',
    image: 'https://cdn.magicpatterns.com/uploads/uRhUzfq8Qxig2SXhJ346xs/PACKDEPLANTILLAS.png'
  }];
  return <section className="relative bg-neutral-bg py-16 px-4 sm:px-6 lg:px-8 border-t border-neutral-beige" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <div className="text-center mb-10" data-id="element-3">
          <span className="inline-block bg-earth-accent/10 text-earth-accent font-bold px-4 py-1 rounded-full mb-3 text-sm tracking-widest uppercase" data-id="element-4">
            Regalos Exclusivos
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A]" data-id="element-5">
            Bonos especiales (gratis hoy)
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-6">
          {bonuses.map((bonus, index) => <a key={index} href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="bg-white rounded-3xl shadow-lg overflow-hidden border border-neutral-beige flex flex-col group cursor-pointer relative transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl" data-id="element-7">
              <div className="w-full aspect-[3/4] overflow-hidden relative bg-neutral-bg" data-id="element-8">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" data-id="element-9" />
                <div className="absolute top-4 right-4 bg-earth-accent text-white font-black text-xs px-3 py-1 rounded-full shadow-lg transform rotate-12 z-10" data-id="element-10">
                  GRATIS
                </div>
                {/* Overlay gradient for text readability if needed, though images are clear */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-11"></div>
              </div>
              <div className="p-5 flex-grow flex flex-col justify-center bg-white relative z-20" data-id="element-12">
                <h4 className="text-base sm:text-lg font-black text-[#1A1A1A] mb-2 leading-tight" data-id="element-13">
                  🎁 {bonus.title}
                </h4>
                <p className="text-gray-600 text-sm font-medium leading-relaxed" data-id="element-14">
                  {bonus.desc}
                </p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}